<script>
// components
import tuitionTable from './tuitionTable'
import expensesTable from './expensesTable';
import feesTable from './feesTable';
import mealsTable from './mealsTable';
import housingTable from './housingTable';
import residencesTable from './residencesTable';
import drawers from './drawers';
import infoPane from './infoPane';
import semesterTuitionRules from './semesterTuitionRules';
import infoIcon from './infoIcon';

// utilities
import formatMoney from '../utilities/formatMoney';

export default {
    name: 'app',

    components: {
        expensesTable,
        tuitionTable,
        feesTable,
        mealsTable,
        housingTable,
        residencesTable,
        drawers,
        infoPane,
        semesterTuitionRules,
        infoIcon
    },

    props: {
        schoolId: null,
        schoolSlug: null,
        year: null,
        calc: {
            default: true
        },
        dev: null
    },

    data() {
        return {
            yearLabel: '',
            eduUnderGradSchoolSlug: "edu-undergrad",
            sidebarElementId: 'tns-calcApp__remotePanel',

            school: null,
            schools: [],
            nestedSchools: [],
            fees: [],
            residences: [],
            residenceHouses: [],
            expenses: [],
            mealPlans: [],
            mealPlansEstimates: [],
            mealPlansVisible: [],
            headingForCostColumn: 'Annual Cost',

            degrees: [],
            undergradDegrees: [],
            gradDegrees: [],
            undergradDegreesGroupedBySchool: {},
            gradDegreesGroupedBySchool: {},
            applicableFees: [],
            applicableExpenses: [],
            total: 0,

            info: [],

            isLoading: true,
            isSchool: false,
            isParis: false,
            disableClearSelectionButton: false,

            maximumYearsOfStudy: 2,

            // http://tns-craft.lcl/parsons/#/?isCalc=true&isNewStudent=true&isInternational=true&hasInsurance=true&whereLive=withfamily&selectedTerm=spring&attendanceStatus=fulltime&yearOfStudy=1&numOfCredits=6&degree=58&mealplan=112

            // user selections -- url param ready
            isCalc: false,
            isNewStudent: 0,
            isInternational: 0,
            hasInsurance: 0,
            whereLive: null,
            selectedTerm: 'fall',
            yearOfStudy: 0,
            // must translate
            selectedDegree: null,
            selectedMealPlan: null,

            showGradDegreesLegend: false,
            showUndergradDegreesLegend: false,
            showGradNotes: false,
            showUndergradNotes: false,
            showHealthInsuranceNote: false,

            // term-specific vars
            fallNumOfCredits: 3,
            fallAttendanceStatus: 0,
            springNumOfCredits: 3,
            springAttendanceStatus: 0,

            tuitionPerTerm: {
                spring: 0,
                fall: 0
            },

            feeQuestions: [],
            texts: null,

            residenceOptionNamesMap: {
                single: 'Single',
                double: 'Double',
                double9months: 'Double (9 Months)',
                double12months: 'Double (12 Months)',
                triple: 'Triple',
                economyDouble: 'Economy double',
                premiumDouble: 'Premium double',
                premiumTriple: 'Premium triple'
            },

            termsMap: {
                spring: {
                    label: "Spring Semester"
                },
                fall: {
                    label: "Fall Semester"
                },
                fullyear: {
                    label: "Full Academic Year"
                }
            },

            urlParams: [
                'isCalc',
                'isNewStudent',
                'isInternational',
                'hasInsurance',
                'whereLive',
                'selectedTerm',
                'yearOfStudy',
                'fallNumOfCredits',
                'fallAttendanceStatus',
                'springNumOfCredits',
                'springAttendanceStatus',
            ]

        }
    },

    mounted() {
        this.isSchool = !!this.schoolSlug;
        this.getData()
    },

    watch: {
        $route() {
            this.handleRoute();
        },
        selectedDegree: function () {

            if (!this.selectedDegree) {
                // reset values
                this.fallNumOfCredits = 3
                this.fallAttendanceStatus = 0
                this.springNumOfCredits = 3
                this.springAttendanceStatus = 0

                this.tuitionPerTerm = {
                    spring: 0,
                    fall: 0
                }

                this.update()

            }
        },
        isCalc: function () {

            if (!this.isCalc) {
                // this.selectedDegree = null;
                // this.selectedMealPlan = null;
                this.turnOffCalculator();
            } else {
                // if there is only one degree, then pre-select it
                if (!this.selectedDegree && this.degrees.length === 1) {
                    this.updateDegree(this.degrees[0].id);
                }
                // if there is only one meal plan, then pre-select it
                if (!this.selectedMealPlan && this.mealPlans.length === 1) {
                    this.updateMealPlan(this.mealPlans[0].id);
                }

                this.disableClearSelectionButton = (this.degrees.length === 1);
            }
        },
        tuition: function () {
            this.calculateTotal()
        }
    },

    updated() {
        this.$nextTick(function () {
            // Code that will run only after the entire view has been re-rendered, init A17/Foundation behaviors
            window.jQuery(document).foundation()
        })
    },

    computed: {
        isUndergrad: function () {
            return this.selectedDegree && this.selectedDegree.level.indexOf("UG") !== -1
        },
        isPerTerm: function () {
            return this.selectedTerm !== "fullyear";
        },
        termText: function () {
            return this.isPerTerm ? "semester" : "year";
        },
        termTextTotal: function () {
            return this.isPerTerm ? "semester" : "annual";
        },
        housingTotal: function () {
            let multiplier = (this.isPerTerm) ? 1 : 2;
            return ['withfamily', 'none'].includes(this.whereLive) ? 0 : this.housingEstimate * multiplier;
        },
        housingEstimate: function () {
            if (this.isParis) {
                return (this.whereLive) ? this.residences.housingEstimatesParis[this.whereLive] : null
            }

            return (this.whereLive) ? this.residences.housingEstimates[this.whereLive] : null
        },
        showWhereLiveNoneOption: function () {
            return this.school.slug === "bpats"
        },
        includeHousingAndMeals: function () {
            return this.whereLive !== 'none'
        },
        whoAmIQuestionsAllAnswered: function () {
            return this.whereLive !== 0
                && this.isInternational !== 0
                && this.isNewStudent !== 0
                && (this.hasInsurance !== 0 || this.isParis);
        },
        tuitionQuestionActive: function () {
            // return this.isCalc && this.askWhichYear
            return this.isCalc && this.selectedDegree
        },
        // askForCredits: function () {
        //
        //     if (!this.selectedDegree) return false;
        //
        //     // rules take precedence: does the current rule require asking for # credits
        //     if (this.activeTuitionRule && this.activeTuitionRule.tuitionMethod === 'perCredit') {
        //
        //         return this.activeTuitionRule.creditRangeMin !== this.activeTuitionRule.creditRangeMax;
        //
        //     }
        //
        //     // otherwise check the basic degree info
        //     return ( this.attendanceStatus === 'parttime' || !this.selectedDegree.fullTimeTuition );
        //
        // },
        // askPartTimeFullTime: function () {
        //
        //     return (
        //         (
        //             this.selectedDegree
        //             // no rule has been set
        //             && !this.activeTuitionRule
        //             // we dont't have to ask which year first
        //             && !this.askWhichYear
        //             // is there a fulltime tuition set
        //             && this.selectedDegree.fullTimeTuition
        //             // and a parttime rate set
        //             && this.selectedDegree.perCreditTuition
        //         )
        //     );
        //
        // },
        // are there any tuition rules that are year-based
        askWhichYear: function () {

            if (!this.selectedDegree) return false;

            // if there is only one year in the program, set it to 1, and skip this
            if (this.selectedDegree.maximumYearsOfStudy === 1) {
                return false;
            }

            // do any degree rules specify a year
            return this.selectedDegree.rules.some((rule) => {
                return rule.yearOfStudy !== 'any'
            });

        },
        askDegreeSpecificFeeQuestions: function () {

            return this.selectedDegree?.feeQuestions.length

        },
        tuition: function () {

            const tuitionCalc = {
                spring: this.tuitionPerTerm.spring,
                fall: this.tuitionPerTerm.fall,
                fullyear: this.tuitionPerTerm.spring + this.tuitionPerTerm.fall
            }

            return tuitionCalc[this.selectedTerm]

        },
        isTuitionReady: function () {

            if (!this.selectedDegree) return false

            const tuitionReadyCheck = {
                spring: this.tuitionPerTerm.spring,
                fall: this.tuitionPerTerm.fall,
                fullyear: this.tuitionPerTerm.spring && this.tuitionPerTerm.fall
            }

            return tuitionReadyCheck[this.selectedTerm]

        },
        isTotalEstimateReady: function () {
            return (
                this.isTuitionReady
                && this.selectedMealPlan
                && this.whoAmIQuestionsAllAnswered
            )
        },
        // tuitionDetailsMessage: function() {
        //     if (!this.isTuitionReady) return false
        //
        //     let html = ''
        //
        //     if (this.isPerCredit) {
        //         html = '<p class="tf-tuitionMessage">Your tuition for the ' + this.termsMap[this.selectedTerm].label + ' term is <b>' + this.formatMoney(tuition) + '</b>.</p><p class="tf-smallNote">' + this.numOfCredits + ' credit' + (this.numOfCredits > 1 ? 's' : '') + ' at ' + this.formatMoney(this.selectedDegree.perCreditTuition) + ' per credit</p>';
        //     } else {
        //         html = '<p class="tf-tuitionMessage">Your full time tuition for the ' + this.termsMap[this.selectedTerm].label + ' term is <b>' + this.formatMoney(tuition) + '</b>.</p>';
        //     }
        //     this.addInfo('tuition', 'Tuition', this.tuition);
        //
        //     return html
        //
        // },
       discount: function() {
          if (this.school.slug !== "bpats") return 0
          // $500/credit per semester capped at $6000 per semester, must be at least 6 credits
          let _discount = 0
          if (this.fallNumOfCredits > 5) {
              _discount += this.fallNumOfCredits > 11 ? 6000 : this.fallNumOfCredits * 500
          }
          if (this.springNumOfCredits > 5) {
              _discount += this.springNumOfCredits > 11 ? 6000 : this.springNumOfCredits * 500
          }
          return _discount
        },
        discountMsg: function() {
          if (this.school.slug !== "bpats") return ""
          return {
            title: "Degree Completion Scholarship",
            body: "A scholarship of " + this.formatMoney(this.discount) + " has been applied."
          }
        },
        estimateMessage: function () {
            if (this.isTotalEstimateReady) {
                return "<p>Your total estimated cost for the " + this.termsMap[this.selectedTerm].label + " is <span>" + this.formatMoney(this.total) + "</span></p>";
            } else {
                return "<p>Please finish making selections to see a total.</p>";
            }
        }

    },

    methods: {
        feeMultiplier: function(fee) {
          return this.isPerTerm ? fee : fee * 2
        },
        getText: function(slug, field = 'body') {
            const text = this.texts.find(function(text) {
                return text.slug === slug
            })
            return text[field]
        },
        // TODO: this gets data for all schools. Should it target the school?
        async getData() {
            try {
                // const response = await fetch('http://tns-craft.lcl/degrees.json')
                const dataUrl = process.env.VUE_APP_API + (this.year ? '?year=' + this.year : '');
                const response = await fetch(dataUrl);
                const data = await response.json();
                this.setData(data)

                this.isLoading = false;

                if (this.$route.query.isCalc === 'true') {
                    this.handleRoute();
                }
                // console.log(this.degrees)
            } catch (error) {
                console.error(error)
            }
        },

        setData(data) {

            let that = this;

            // general
            this.yearLabel = data.info.yearLabel;

            // filter by school for current page by school id (from Craft)
            if (this.isSchool) {

                // degrees can be in multiple schools
                this.degrees = data.degrees.filter((d) => {
                    return d.schools.some((school) => {
                        return school.slug === that.schoolSlug;
                    });
                });

                this.school = data.schools.find((school) => {
                    return school.slug === that.schoolSlug;
                });

                this.isParis = this.school?.slug === "parsons-paris"

            } else {

                // only include undergrad degrees marked as EDU
                this.degrees = data.degrees.filter((d) => {

                    if (d.level.indexOf("GR") !== -1) {
                        return true;
                    } else {
                        let inEdu = false;
                        d.schools.forEach((school) => {
                            inEdu = (school.slug === that.eduUnderGradSchoolSlug);
                        });
                        return inEdu;
                    }
                });

            }

            this.schools = data.schools;

            // build the nested set of schools
            let nestedSchools = []

            data.schools.map(school => {

                if (!school.parentId) {
                    // top level
                    school.children = [] // initiate child schools array
                    nestedSchools[school.id] = school
                } else {
                    // sub school
                    nestedSchools[school.parentId].children.push(school)
                }

            })

            this.nestedSchools = nestedSchools

            this.setDegrees();

            this.expenses = this.isParis ? data.expensesParis : data.expenses;
            this.applicableExpenses = this.expenses;

            this.fees = data.fees;
            // filter out school-specific fees for other schools
            if (this.isSchool) {
                this.fees = this.fees.filter((fee) => {
                    // if schools are indicated and this school id not in schools array then remove it
                    return !(fee.conditions.schools && fee.conditions.schools.length && fee.conditions.schools.indexOf(that.school.id) === -1);
                });
            }
            this.applicableFees = this.fees;

            this.mealPlans = data.mealPlans;
            if (this.isSchool) {
                if (this.isParis) {
                    this.mealPlans = this.mealPlans.filter(plan => plan.planType.value === 'paris')
                } else {
                    this.mealPlans = this.mealPlans.filter(plan => plan.planType.value !== 'paris')
                }
            }
            this.setMealPlans();

            this.residences = data.residences;
            this.setResidences();

            this.texts = data.texts

        },

        setDegrees() {

            let that = this;

            this.undergradDegrees = [];
            this.gradDegrees = [];
            this.gradDegreesGroupedBySchool = [];

            // sort into UG/G
            this.degrees.forEach((degree) => {
                // if a degree has been selected, then it's the only degree to include in an array
                if (!that.isCalc || (!that.selectedDegree) || (that.selectedDegree && that.selectedDegree.id === degree.id)) {
                    if (degree.level.indexOf("UG") !== -1) {
                        that.undergradDegrees.push(degree);
                    } else {
                        that.gradDegrees.push(degree);
                    }
                }
            });

            // console.log(this.undergradDegrees);

            // group degrees into schools (.edu only)
            if (!this.isSchool) {

                let schoolSlug = that.eduUnderGradSchoolSlug;

                this.undergradDegreesGroupedBySchool[0] =
                    {
                        id: 0,
                        title: that.getSchoolBySlug(schoolSlug).title,
                        fullName: that.getSchoolBySlug(schoolSlug).fullName,
                        notes: that.getSchoolBySlug(schoolSlug).undergradNotes,
                        degrees: this.undergradDegrees
                    };

                // assign degrees to nested schools & filter schools with no grad programs
                this.gradDegreesGroupedBySchool = this.nestedSchools.filter(school => {

                    school.degrees = this.findGradDegreesBySchool(this.gradDegrees, school)

                    school.children.map(subschool => {

                        subschool.degrees = this.findGradDegreesBySchool(this.gradDegrees, subschool)

                    })

                    school.children = school.children.filter(subschool => {
                        return subschool.degrees.length
                    })

                    return (school.degrees.length || school.children.length)

                })

                // console.log(that.undergradDegreesGroupedBySchool)
                // console.log(that.gradDegreesGroupedBySchool);

            }

        },

        findGradDegreesBySchool(degrees, school) {
            return degrees.filter(degree => {
                return degree.schools.some(degreeSchool => degreeSchool.id === school.id) && degree.level.includes('GR')
            })
        },

        getSchoolBySlug(slug) {
            return this.schools.find((school) => {
                return school.slug === slug;
            })
        },

        getSchoolById(id) {
            return this.schools.find((school) => {
                return school.id === id;
            })
        },

        selectDegree(value) {

            // if the selected degree was selected, then unselect it
            if (value == 0) {
                this.selectedDegree = null;
                this.setDegrees();
                return;
            }

            let theDegree = this.degrees.filter(function (d) {
                return d.id === value;
            });

            this.selectedDegree = theDegree[0];

            this.maximumYearsOfStudy = this.selectedDegree.maximumYearsOfStudy;

            // if there is only one year in the program, set it
            if (this.selectedDegree.maximumYearsOfStudy === 1) {
                this.yearOfStudy = 1;
            }

            this.setDegrees();
            // selecting a degree could change mealplan options ??
            // this.setMealPlans()

        },

        // setDegreeRule() {
        //
        //     // if (!this.selectedDegree) return false;
        //
        //     const _self = this;
        //     let applicableRules = [];
        //
        //     // find all rules for the year of study that also match the term we're calculating for
        //     applicableRules = this.selectedDegree.rules.filter( (rule) => {
        //
        //         let yearMatch = false;
        //
        //         // if a year of study has been selected,
        //         if (this.yearOfStudy && rule.yearOfStudy !== 'any') {
        //
        //             switch (rule.yearOperator) {
        //                 case '=':
        //                     // fuzzy for integer/string matches
        //                     yearMatch = (rule.yearOfStudy == _self.yearOfStudy);
        //                     break;
        //
        //                 case '<':
        //                     yearMatch = (rule.yearOfStudy < _self.yearOfStudy);
        //                     break;
        //
        //                 case '>':
        //                     yearMatch = (rule.yearOfStudy > _self.yearOfStudy);
        //                     break;
        //
        //             }
        //         } else {
        //             yearMatch = true;
        //         }
        //
        //         return (
        //             yearMatch && ['any', _self.selectedTerm].includes(rule.term)
        //         );
        //
        //     });
        //
        //     // return 1st match
        //     this.activeTuitionRule = applicableRules[0] || null;
        //
        //     if (this.activeTuitionRule) {
        //         this.numOfCredits = this.activeTuitionRule.creditRangeMin;
        //     }
        //
        // },

        setYearOfStudy(e) {
            this.yearOfStudy = e.target.value;
            this.update();
        },

        selectMealPlan(mealPlanId) {

            // if the alreddy selected meal plan was selected, then unselect it
            if (mealPlanId == 0) {
                this.selectedMealPlan = null;
                this.setMealPlans();
                return;
            }

            let p = this.mealPlans.filter(function (plan) {
                return plan.id === mealPlanId;
            });

            this.selectedMealPlan = p[0];

            this.setMealPlans();

        },

        setMealPlans() {

            if (this.selectedMealPlan) {
                this.mealPlansVisible = [this.selectedMealPlan]
            } else {
                // first year on-campus students must select a plan: filter out meal plans of type 'none'
                // TODO: && this.isUndergrad ??
                if (this.isNewStudent && this.whereLive === 'oncampus' && !this.isParis) {
                    this.mealPlansVisible = this.mealPlans.filter(plan => plan.planType.value !== 'none')
                    return
                }

                this.mealPlansVisible = this.mealPlans
            }

            // this.mealPlansTNS = availableMealPlans.filter(plan => plan.isNewSchoolMealPlan);
            // this.mealPlansEstimates = availableMealPlans.filter(plan => !plan.isNewSchoolMealPlan);

        },

        setResidences() {

            let that = this;

            this.headingForCostColumn = this.residences.headingForCostColumn;

            this.residences.residences.forEach((res) => {

                let row = {
                    name: res.name,
                    costs: []
                };

                let count = 0;

                for (let [optionName, optionValue] of Object.entries(res.costs)) {

                    // res.costs.each( (optionValue, optionName) => {

                    if (optionValue) {
                        row.costs.push({
                            id: count,
                            name: that.residenceOptionNamesMap[optionName],
                            annualCost: optionValue,
                            newStudentDeposit: this.residences.newStudentDeposit,
                            continuingStudentDeposit: this.residences.continuingStudentDeposit
                        })
                    }
                    count++;
                }

                that.residenceHouses.push(row);

            })

        },

        toggleCalc() {

            const boolString = this.isCalc === true ? 'false' : 'true';
            this.$router.push({path: this.$route.path, query: {...this.$route.query, isCalc: boolString}});

        },

        resetCalc() {

            this.$router.push({path: this.$route.path, query: { isCalc: 'true' }});
            this.$router.go(0);

        },

        // handle route change
        handleRoute() {

            if (!this.isCalc && !this.$route.query.isCalc) return false

            const _self = this;

            // console.log(this.$route.query)

            Object.keys(this.$route.query).forEach(function (paramKey) {

                if (_self.urlParams.includes(paramKey)) {

                    let value = _self.$route.query[paramKey];

                    // convert some values to booleans
                    if (['true', 'false'].includes(value)) {
                        value = (_self.$route.query[paramKey] === 'true');
                    }
                    // convert number string values to integers
                    else {
                        const integerTest = parseInt(value, 10);
                        if (!Number.isNaN(integerTest)) {
                            value = integerTest;
                        }
                    }

                    _self[paramKey] = value;

                }

                // capture and assign any degree-specific questions
                if (paramKey.includes('feeQuestions')) {
                    const questionId = paramKey.match(/\[(.*?)\]/)[1]
                    _self.feeQuestions[questionId] = (_self.$route.query[paramKey] === 'true')
                }

            });

            // set degree
            if (this.$route.query.degree) {
                const degreeParam = parseInt(this.$route.query.degree, 10)
                // check if degree id exists
                const degreeExists = _self.degrees.some((degree) => {
                    return degree.id === degreeParam;
                });
                const degreeId = (degreeExists) ? degreeParam : 0;
                this.selectDegree(degreeId);
            } else {
                this.selectDegree(0);
            }

            // set meal plan
            if (this.$route.query.mealplan) {
                // check if mealplan id exists
                const mealPlanQueryId = parseInt(this.$route.query.mealplan, 10);
                const planExists = _self.mealPlans.some((plan) => {
                    return plan.id === mealPlanQueryId;
                });
                const mealplanId = (planExists) ? mealPlanQueryId : 0;

                this.selectMealPlan(parseInt(mealplanId, 10));
            } else {
                this.selectMealPlan(0);
            }

            this.setApplicableFees();

            this.calculateTotal();

        },

        updateDegree(id) {
            // if the id is the same, set to 0 to deselect
            id = (this.selectedDegree && this.selectedDegree.id === id) ? 0 : id;
            this.$router.push({path: this.$route.path, query: {...this.$route.query, degree: id}})
        },

        updateMealPlan(id) {
            // if the id is the same, set to 0 to deselect
            id = (this.selectedMealPlan && this.selectedMealPlan.id === id) ? 0 : id;
            this.$router.push({path: this.$route.path, query: {...this.$route.query, mealplan: id}})
        },

        // route
        update() {
            const _self = this;
            const queryParams = {};

            this.urlParams.forEach(function (param) {
                queryParams[param] = _self[param];
            });

            _self.$router.push({path: _self.$route.path, query: {...this.$route.query, ...queryParams}})

        },

        updateFeeQuestion(e) {

            const questionId = e.target.name.split('-')[1]

            this.feeQuestions[questionId] = e.target.value

            const feeQuestionParams = {}
            this.feeQuestions.map((question, key) => {
                feeQuestionParams['feeQuestions[' + key + ']'] = e.target.value
            })

            this.$router.push({path: this.$route.path, query: {
                ...this.$route.query,
                ...feeQuestionParams
            }})

        },

        updateTuition(tuition) {
            this.tuitionPerTerm[tuition.term] = tuition.value
        },

        updateTerm(termData) {

            const updatedParams = {}
            updatedParams[termData.term + 'NumOfCredits'] = termData.numOfCredits
            updatedParams[termData.term + 'AttendanceStatus'] = termData.attendanceStatus

            this.$router.push({path: this.$route.path, query: {...this.$route.query, ...updatedParams}}).catch(err => {
                err
            })

        },

        addInfo(section, label, value) {

            this.info.push({
                id: this.info.length,
                section: section,
                label: label,
                value: value
            })

        },

        formatMoney,

        // calculateTuition() {
        //
        //     let tuition = 0;
        //     let html = '';
        //
        //     if (this.selectedDegree) {
        //
        //         tuition = this.tuitionPerTerm.spring + this.tuitionPerTerm.spring;
        //
        //         if(this.isPerCredit) {
        //             html = '<p class="tf-tuitionMessage">Your tuition for the ' + this.termsMap[this.selectedTerm].label + ' term is <b>' + this.formatMoney(tuition) + '</b>.</p><p class="tf-smallNote">' + this.numOfCredits + ' credit' + (this.numOfCredits > 1 ? 's' : '') + ' at ' + this.formatMoney(this.selectedDegree.perCreditTuition) + ' per credit</p>';
        //         } else {
        //             html = '<p class="tf-tuitionMessage">Your full time tuition for the ' + this.termsMap[this.selectedTerm].label + ' term is <b>' + this.formatMoney(tuition) + '</b>.</p>';
        //         }
        //         this.addInfo('tuition', 'Tuition', tuition);
        //
        //     }
        //
        //     return {
        //         tuition: tuition,
        //         text: html
        //     };
        // },

        calculateTotal() {

            let _self = this;

            // reset
            this.info = [];

            // term based cost multiplier = 1 or 2
            let termsCostMultiplier = (this.isPerTerm) ? 1 : 2;

            // annual based multiplier = 1 or .5
            // let annualCostMultiplier = (this.isPerTerm) ? 0.5 : 1;

            // add tuition
            let total = this.tuition
            _self.addInfo('tuition', 'Tuition', this.tuition);

            // add degree-specific fees
            if (_self.selectedDegree) {
                this.feeQuestions.forEach(function (question, key) {
                    if (question) {
                        const questionData = _self.selectedDegree.feeQuestions.find(function (feeQ) {
                            return parseInt(feeQ.id, 10) === key
                        })
                        if (questionData) {
                            total += (termsCostMultiplier * questionData.fee)
                            _self.addInfo('degree-fees', questionData.name, termsCostMultiplier * questionData.fee);
                        }
                    }
                })
            }

            // add fees / per term
            this.applicableFees.forEach(function (fee) {

                // don't multiply one-time fees
                let frequencyMultiplier = (['once', 'springTermOnly', 'fallTermOnly'].includes(fee.frequency)) ? 1 : termsCostMultiplier;

                let t = frequencyMultiplier * parseInt(fee.amount);
                total += t;

                _self.addInfo('fees', fee.fullName, t);

            });

            // add housing
            total += _self.housingTotal;

            // add food / per term
            if (this.selectedMealPlan) {

                let t = parseInt(this.selectedMealPlan.costPerTerm) * termsCostMultiplier;

                total += t;

                _self.addInfo('meals', this.selectedMealPlan.name, t);
            }

            // add expenses
            if (this.whereLive) {
                let expenseKey = (this.whereLive !== 'withfamily') ? 'onOffCampusAmount' : 'withRelativesAmount';
                this.expenses.forEach(function (expense) {

                    let t = parseInt(expense[expenseKey]) * termsCostMultiplier;
                    total += t;
                    _self.addInfo('expenses', expense.nameOfCost, t);

                });
                this.applicableExpenses = this.expenses;
            } else {
                this.applicableExpenses = [];
            }

            // subtract discounts
            total -= this.discount

            this.total = total;

        },

        turnOffCalculator() {

            // reset fee table to show all fees
            this.applicableFees = this.fees;
            this.mealPlansVisible = this.mealPlans;
            this.applicableExpenses = this.expenses;

            this.setDegrees();

        },

        setApplicableFees() {

            // reject route changes when the calc is not engaged
            if (!this.isCalc) return false;

            let that = this;

            // clear applicable fees
            this.applicableFees = [];

            if (!this.whoAmIQuestionsAllAnswered) return false;

            // loop thru conditions
            this.fees.forEach((fee) => {

                // if the all condition is set, it overrides all other possible conditions
                if (fee.conditions.all) {
                    this.applicableFees.push(fee);
                    return;
                }

                // if the fee is 'occasional', it is not included in the calc, skip it
                if (fee.frequency === 'occasional') {
                    return;
                }

                // all values of this array must be true to include the fee
                let conditionsCheck = [];

                // skip fees not applicable to current term
                if (
                    (fee.frequency === 'fallTermOnly' && this.selectedTerm === 'spring')
                    ||
                    (fee.frequency === 'springTermOnly' && this.selectedTerm === 'fall')
                ) {
                    return;
                }

                // campus check
                if (fee.campus !== 'both') {
                  if (fee.campus === "parisOnly" && !this.isParis) return;
                  if (fee.campus === "newYorkOnly" && this.isParis) return;
                }

                Object.keys(fee.conditions).forEach((conditionKey) => {

                    const conditionValue = fee.conditions[conditionKey];

                    // check if the condition matches the state of the calculator
                    switch (conditionKey) {

                        // TODO: name this field back to international
                        case 'international2':
                            if (conditionValue !== 'any') {
                              conditionsCheck.push(conditionValue
                                  && (
                                      that.isInternational === true && conditionValue === 'international'
                                      ||
                                      that.isInternational === false && conditionValue === 'notInternational'
                                  )
                              );
                            }
                            break;

                        case 'firstTerm':
                            conditionsCheck.push(conditionValue && that.isNewStudent === true);
                            break;

                        case 'insurance':
                              conditionsCheck.push(conditionValue && that.hasInsurance === false);
                            break;

                        case 'schools':
                            conditionsCheck.push(conditionValue.length && conditionValue.indexOf(that.school.id) !== -1);
                            break;

                        case 'level':
                            if (that.selectedDegree) {
                                // TODO: this may need refinement, may not work as expected for all levels conditions
                                // if the first value in the selectedDegree.level array is one of the levels this fee applies to
                                conditionsCheck.push(fee.conditions['level'].length && fee.conditions['level'].some(lev => that.selectedDegree.level.includes(lev)));
                            } else {
                                conditionsCheck.push(false)
                            }
                            break;
                    }

                });

                if (conditionsCheck.indexOf(false) === -1) {
                    this.applicableFees.push(fee);
                }

            })

        }

    }
}
</script>

<template>
    <div id="calc-app" :class="{isSchool:isSchool, isCalc:isCalc}">

        <div v-if="isLoading" class="tf-loading">
            <h3>Loading tuition and fees...</h3>
        </div>
        <div v-else>

            <infoPane v-if="isCalc"
                      :sidebarElementId="sidebarElementId"
                      :info="info"
                      :housingTotal="housingTotal"
                      :isTotalEstimateReady="isTotalEstimateReady"
                      :isTuitionReady="isTuitionReady"
                      :tuition="tuition"
                      :selectedDegree="selectedDegree"
                      :schoolId="schoolId"
                      :discount="discount"
                      :discountMsg="discountMsg"
                      :total="total"
                      :year="yearLabel"
                      :term="selectedTerm"
                      :termsMap="termsMap"
                      :disclaimer="getText('disclaimer')"
            />

            <div v-if="isSchool && calc" class="tf">

                <div class="actions">
<!--                    <a class="a-btn a-btn&#45;&#45;block a-btn&#45;&#45;highlight" href="/lang/how-to-apply/">See My Estimated Costs</a>-->
                    <a class="a-btn a-btn--block a-btn--highlight" @click="toggleCalc">
                        <span v-if="!isCalc">See My Estimated Costs</span>
                        <span v-if="isCalc">Turn off the Cost Estimator</span>
                    </a>

                    <a v-if="isCalc" class="a-btn a-btn--block a-btn--grey--light reset" @click="resetCalc">
                        <span>Reset the Estimator</span>
                    </a>
                </div>

                <div v-if="isCalc">
                    <p class="tf-step"><span>Step 1:</span> Tell us about yourself</p>

                    <div class="tf-whoAreYou">

                        <!-- New Student -->
                        <div>
                            <p class="tf-selectorLabel">Student status:</p>
                            <div>
                                <label class="tf-radio">
                                  <span class="tf-radio__input">
                                    <input type="radio" name="isNewStudent" v-model="isNewStudent" value="true" @change="update">
                                    <span class="tf-radio__control"><span></span></span>
                                  </span>
                                    <span class="tf-radio__label">I am a new student</span>
                                </label>

                                <label class="tf-radio">
                                  <span class="tf-radio__input">
                                    <input type="radio" name="isNewStudent" v-model="isNewStudent" value="false" @change="update">
                                    <span class="tf-radio__control"><span></span></span>
                                  </span>
                                    <span class="tf-radio__label">I am a returning student</span>
                                </label>
                            </div>
                        </div>

                        <!-- Is International -->
                        <div>
                            <p class="tf-selectorLabel">Student Citizenship:</p>
                            <div>
                                <label class="tf-radio">
                                  <span class="tf-radio__input">
                                    <input type="radio" name="isInternational" v-model="isInternational" value="false" @change="update">
                                    <span class="tf-radio__control"><span></span></span>
                                  </span>
                                    <span class="tf-radio__label">US Citizen/Permanent Resident</span>
                                </label>

                                <label class="tf-radio">
                                  <span class="tf-radio__input">
                                    <input type="radio" name="isInternational" v-model="isInternational" value="true" @change="update">
                                    <span class="tf-radio__control"><span></span></span>
                                  </span>
                                    <span class="tf-radio__label">Non-US Citizen</span>
                                </label>
                            </div>
                        </div>

                        <!-- Health Insurance -->
                        <div v-if="!isParis">
                            <p class="tf-selectorLabel tf-hasLegend" @click="showHealthInsuranceNote = !showHealthInsuranceNote">Health insurance:<infoIcon /></p>
                            <div v-if="showHealthInsuranceNote" class="tf-degreeLegend" v-html="getText('health-insurance-info-note')"></div>
                            <div>
                                <label class="tf-radio">
                                  <span class="tf-radio__input">
                                    <input type="radio" name="hasInsurance" v-model="hasInsurance" value="true" @change="update">
                                    <span class="tf-radio__control"><span></span></span>
                                  </span>
                                    <span class="tf-radio__label">I have my own insurance</span>
                                </label>

                                <label class="tf-radio">
                                  <span class="tf-radio__input">
                                    <input type="radio" name="hasInsurance" v-model="hasInsurance" value="false" @change="update">
                                    <span class="tf-radio__control"><span></span></span>
                                  </span>
                                    <span class="tf-radio__label">I need insurance</span>
                                </label>
                            </div>
                        </div>

                        <!-- Where live -->
                        <div>
                            <p class="tf-selectorLabel">Where will you live:</p>
                            <div>
                                <label class="tf-radio">
                                  <span class="tf-radio__input">
                                    <input type="radio" name="whereLive" v-model="whereLive" value="oncampus" @change="update">
                                    <span class="tf-radio__control"><span></span></span>
                                  </span>
                                    <span class="tf-radio__label">On Campus</span>
                                </label>

                                <label class="tf-radio">
                                  <span class="tf-radio__input">
                                    <input type="radio" name="whereLive" v-model="whereLive" value="offcampus" @change="update">
                                    <span class="tf-radio__control"><span></span></span>
                                  </span>
                                    <span class="tf-radio__label">Off Campus</span>
                                </label>

                                <label class="tf-radio">
                                  <span class="tf-radio__input">
                                    <input type="radio" name="whereLive" v-model="whereLive" value="withfamily" @change="update">
                                    <span class="tf-radio__control"><span></span></span>
                                  </span>
                                    <span class="tf-radio__label">With Family</span>
                                </label>

                                <label v-if="showWhereLiveNoneOption" class="tf-radio">
                                  <span class="tf-radio__input">
                                    <input type="radio" name="whereLive" v-model="whereLive" value="none" @change="update">
                                    <span class="tf-radio__control"><span></span></span>
                                  </span>
                                    <span class="tf-radio__label">Exclude housing costs</span>
                                </label>
                            </div>
                        </div>
                    </div>

                    <!-- Choose Semester -->
                    <div>
                        <p class="tf-step"><span>Step 2:</span> Choose a period to calculate:</p>
                        <p class="tf-selectorLabel">Calculate an estimate for:</p>
                        <p class="tf-smallNote">Current academic year</p>
                        <div>
                            <label class="tf-radio">
                              <span class="tf-radio__input">
                                <input type="radio" name="selectedTerm" v-model="selectedTerm" value="fall" @change="update">
                                <span class="tf-radio__control"><span></span></span>
                              </span>
                                <span class="tf-radio__label">Fall Semester</span>
                            </label>

                            <label class="tf-radio">
                              <span class="tf-radio__input">
                                <input type="radio" name="selectedTerm" v-model="selectedTerm" value="spring" @change="update">
                                <span class="tf-radio__control"><span></span></span>
                              </span>
                                <span class="tf-radio__label">Spring Semester</span>
                            </label>

                            <label class="tf-radio">
                              <span class="tf-radio__input">
                                <input type="radio" name="selectedTerm" v-model="selectedTerm" value="fullyear" @change="update">
                                <span class="tf-radio__control"><span></span></span>
                              </span>
                                <span class="tf-radio__label">Full Academic Year</span>
                            </label>
                        </div>
                    </div>

                </div>

            </div>

            <h2 v-if="isSchool">Tuition</h2>
            <div class="tf-leader" v-html="getText('tuition-leader')"></div>
            <p v-if="isCalc" class="tf-step"><span>Step 3:</span> Select a degree program from the table(s) below and
                answer any questions.</p>
            <div v-if="undergradDegrees.length || gradDegrees.length">

                <div v-if="undergradDegrees.length">
                    <div v-if="isSchool">
                        <h4 @click="showUndergradDegreesLegend = !showUndergradDegreesLegend" class="tf-hasLegend">Undergraduate<infoIcon /></h4>
                        <div v-if="showUndergradDegreesLegend" class="tf-degreeLegend" v-html="getText('undergraduate-degrees-legend')"></div>
                        <tuitionTable :isCalc="isCalc"
                                      :degrees="undergradDegrees"
                                      :selectedDegree="selectedDegree"
                                      :disableClearSelectionButton="disableClearSelectionButton"
                                      @select-degree="updateDegree"
                                      :isUndergrad="true"
                        />
                    </div>
                    <div v-else>
                        <h2>Undergraduate</h2>
                        <drawers :groupedPrograms="undergradDegreesGroupedBySchool" :isUndergrad="true"/>
                    </div>

                    <div v-if="isSchool && school.undergradNotes">
                        <h3 class="tf--showNote" @click="showUndergradNotes = !showUndergradNotes">Additional Program Information<infoIcon /></h3>
                        <div class="tf--showNote__content" v-if="showUndergradNotes" v-html="school.undergradNotes"></div>
                    </div>

                </div>

                <div v-if="gradDegrees.length">
                    <div v-if="isSchool">
                        <h4 @click="showGradDegreesLegend = !showGradDegreesLegend" class="tf-hasLegend">Graduate<infoIcon /></h4>
                        <div v-if="showGradDegreesLegend" class="tf-degreeLegend" v-html="getText('graduate-degrees-legend')"></div>
                        <tuitionTable :isCalc="isCalc"
                                      :degrees="gradDegrees"
                                      :selectedDegree="selectedDegree"
                                      :disableClearSelectionButton="disableClearSelectionButton"
                                      @select-degree="updateDegree"
                                      :isUndergrad="false"
                        />
                    </div>
                    <div v-else>
                        <h2>Graduate</h2>
                        <drawers :groupedPrograms="gradDegreesGroupedBySchool" :isUndergrad="true"/>
                    </div>

                    <div v-if="isSchool && school.gradNotes">
                        <h3 class="tf--showNote" @click="showGradNotes = !showGradNotes">Additional Program Information<infoIcon /></h3>
                        <div class="tf--showNote__content" v-if="showGradNotes" v-html="school.gradNotes"></div>
                    </div>

                    <div v-html="getText('maintenance-of-status')"></div>
                </div>

            </div>
            <div v-else>
                <p class="tf-error">No degrees found.</p>
            </div>

            <div v-if="tuitionQuestionActive">

                <!-- ask which year if a rule requires it -->
                <div v-if="askWhichYear">
                    <label class="tf-selectorLabel" for="yearOfStudy">What year of study are you in?</label>
                    <select v-model="yearOfStudy" id="yearOfStudy" class="tf-selector" @change="setYearOfStudy">
                        <option value="0">Select a Year</option>
                        <option v-for="i in maximumYearsOfStudy" v-bind:value="i" v-bind:key="i"> {{ i }}</option>
                    </select>
                </div>

                <div v-if="!askWhichYear || (askWhichYear && yearOfStudy)">
                    <semesterTuitionRules v-if="['fullyear','fall'].includes(selectedTerm)"
                                          key="fallTuition"
                                          @update="updateTerm"
                                          @update-tuition="updateTuition"
                                          term="fall"
                                          :school="school"
                                          :degree="selectedDegree"
                                          :yearOfStudy="yearOfStudy"
                                          :termsMap="termsMap"
                                          :numOfCredits="fallNumOfCredits"
                                          :attendanceStatus="fallAttendanceStatus"
                    />
                    <semesterTuitionRules v-if="['fullyear','spring'].includes(selectedTerm)"
                                          key="springTuition"
                                          @update="updateTerm"
                                          @update-tuition="updateTuition"
                                          term="spring"
                                          :school="school"
                                          :degree="selectedDegree"
                                          :yearOfStudy="yearOfStudy"
                                          :termsMap="termsMap"
                                          :numOfCredits="springNumOfCredits"
                                          :attendanceStatus="springAttendanceStatus"
                    />
                </div>

                <!-- ask any degree-specific fee questions -->
                <div v-if="askDegreeSpecificFeeQuestions" class="tf tf--calcBox">
                    <div v-for="question in selectedDegree.feeQuestions" :key="question.id">
                        <div v-html="question.question" ></div>
                        <p class="tf-smallNote">{{ question.name }}: {{ feeMultiplier(question.fee) | toCurrency }}</p>
                        <div>
                            <label class="tf-radio">
                          <span class="tf-radio__input">
                            <input type="radio" :name="'question-' + question.id"
                                   v-model="feeQuestions[question.id]" value="true" @change="updateFeeQuestion">
                            <span class="tf-radio__control"><span></span></span>
                          </span>
                                <span class="tf-radio__label">Yes</span>
                            </label>

                            <label class="tf-radio">
                          <span class="tf-radio__input">
                            <input type="radio" :name="'question-' + question.id" v-model="feeQuestions[question.id]" value="false" @change="updateFeeQuestion">
                            <span class="tf-radio__control"><span></span></span>
                          </span>
                                <span class="tf-radio__label">No</span>
                            </label>
                        </div>
                    </div>
                </div>

            </div>

            <div v-if="isInternational && !isParis" v-html="getText('citizenship-non-us')"></div>

            <h2>University Fees</h2>
            <div class="tf-leader" v-html="getText('fees-leader')"></div>
            <feesTable :isCalc="isCalc" :isParis="isParis" :fees="applicableFees"/>

            <div v-if="residenceHouses.length && !isCalc && !isParis">
                <h2>University Housing</h2>
                <residencesTable v-for="residenceHouse in residenceHouses" :key="residenceHouse.id" :data="residenceHouse" :headingForCostColumn="headingForCostColumn"/>
            </div>
            <div v-else>
                <div v-if="includeHousingAndMeals">
                  <h2>Housing</h2>
                  <housingTable
                                :isCalc="isCalc"
                                :isParis="isParis"
                                :whereLive="whereLive"
                                :housingEstimate="housingEstimate"
                                :parisEstimates="residences.housingEstimatesParis"
                                :estimateMessage="isParis ? getText('housing-on-campus-estimate-paris') : getText('housing-on-campus-estimate')"
                  />
                </div>
            </div>

            <h2>Meals</h2>
            <p v-if="isCalc" class="tf-step"><span>Step 4:</span> Select a meal plan.</p>
            <div v-if="mealPlansVisible.length">
                <mealsTable :mealPlans="mealPlansVisible" :mealPlansCount="mealPlans.length" :isCalc="isCalc" :selectedMealPlan="selectedMealPlan" @select-meal-plan="updateMealPlan"/>
            </div>
            <div v-if="isCalc && !isParis && isNewStudent && whereLive==='oncampus' && isUndergrad" v-html="getText('meals-first-year-undergraduate-students-living-in-on-campus')" />

            <h2>Other Costs of Attendance</h2>
            <div v-if="isParis" class="tf-leader" v-html="getText('other-costs-leader-paris')"></div>
            <div v-else class="tf-leader" v-html="getText('other-costs-leader')"></div>
            <expensesTable :expenses="applicableExpenses" :whereLive="whereLive" :isCalc="isCalc"/>

            <div v-if="discount && isCalc" >
              <h2>{{ discountMsg.title }}</h2>
              <p>{{ discountMsg.body }}</p>
            </div>

            <div v-if="isCalc">
                <h2>Estimate Total</h2>
                <div class="tf tf--calcBox tf--totalsBox" v-html="estimateMessage"></div>
            </div>

        </div>

    </div>
</template>

<!-- load all styles -->
<style lang="scss">
@import "~@/assets/style/app.scss";
</style>
